export const speedMateQuery = "?speedMateCode";
export const speedMateCodeString = "speedMateCode";
export const autoOasisCodeQuery = "?autooasisCode";
export const autoOasisCodeString = "autooasisCode";
export enum PATH {
  HOME = "/",
  LOGIN = "/",
  REGISTER = "/register",
  RE_REGISTER = "/re-register",
  PWD_RESET = "/pwd_reset",
  UNBOOKABLE = "/unbookable",
  RESERVATION = "/reservations",
  SETTLEMENT = "/settlement",
  LABOR_FEE = "/labor-fee",
  APP_CONFIRM = "/app-confirm",
  SPEED_MATE_RESERVATION = `/speed-mate-reservations`,
  AUTO_OASIS_RESERVATION = `/autooasis-reservations`,
}
